export const Aboutinfo =
    [
        {
            name: 'Abhiraj Chatterjee',
            image: '/assets/ProfilePhotos/Abhiraj.png',
            description: 'Web and Android developer. BTech(CSE) at KIIT University.',
            language: 'Java, Dart, JavaScript',
            source: "https://www.linkedin.com/in/abhiraj-chatterjee-15415b202/",
            source1: "https://github.com/Abhiraj3112000",
            source2: "https://aveeqprofile.netlify.app/",
            email: "mailto:1905003@kiit.ac.in"
        }, {
            name: 'Kankana Dolai',
            image: '/assets/ProfilePhotos/kankana.png',
            description: 'Front-end Developer, Machine Learning Enthusiast. BTech(CSE) at KIIT University.',
            language: 'Python, JavaScript',
            source: "https://www.linkedin.com/in/kankana-dolai-324303209/",
            source1: "https://github.com/usagi24",
            source2: "#",
            email: "mailto:dolaikankana2001@gmail.com"
        },
        {
            name: 'Salokya Kumar',
            image: '/assets/ProfilePhotos/Salokya.png',
            description: 'Full-stack development, Cyber Security & Penetration Testing Enthusiast. BTech(CSE) student at KIIT University, Bhubaneswar, India.',
            language: 'Java, Kotlin, JavaScript, Bash',
            source: "https://www.linkedin.com/in/salokya-kumar/",
            source1: "https://github.com/ksalokya",
            source2: "https://salokyakumar.me/",
            email: "mailto:kumar.salokya007@gmail.com"
        },
        {
            name: 'Sayan Bhattacharyya',
            image: '/assets/ProfilePhotos/Sayan.png',
            description: 'Full-stack development, Backend Development Enthusiast. BTech(CSE) at KIIT University.',
            language: 'Java, Kotlin, Python, TypeScript',
            source: "https://www.linkedin.com/in/sayan-bhattacharyya-aa44a61a4/",
            source1: "https://github.com/Sayan3990",
            source2: "https://sayan3990.github.io/",
            email: "mailto:sayan.bhatta2017@gmail.com"
        },
        {
            name: 'Yash Mishra',
            image: '/assets/ProfilePhotos/Yashprofilepic.png',
            description: 'Font-end and Android developer. BTech(CSE) at KIIT University.',
            language: 'Java, JavaScript',
            source: "https://www.linkedin.com/in/yash-mishra-1847aa1aa/",
            source1: "https://github.com/Yash15-maker",
            source2: "https://yashcv.netlify.app/",
            email: "mailto:1905073@kiit.ac.in"
        }
    ];